import { ActionTypes } from "../../constants/ActionTypes";
import { IreceiversOrg } from "../../interfaces";
import { IReminderReducer } from "../../interfaces/Reminder";

const INIT_STATE: IReminderReducer = {
  reminderModel: {
    letterCode: "",
    deadLine: "",
    receiverCode: [],
    text: "",
  },
  reminder: {
    approvedItems: [],
    forceItems: [],
    pendingItems: [],
  },
  reminderNotify: {
    approvedItems: [],
    forceItems: [],
    pendingItems: [],
  },
  isNotify: false,
  pageIndex: 0,
  notifyId: 0,
  success: false,
  isFinal: false,
  reminderReceivers: [],
  append: false,
  onlyApproved: false,
  onlyforce: false,
  loadingInstance: true,
  endOfList: false,
  endOfPendingList: false,
  sendRequest: false,
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_REMINDER_SUCCESS: {
      let { reminder, reminderNotify, onlyApproved, onlyforce, isNotify } =
        state;
      let s = { ...state };

      let approvedItems =
        onlyApproved == null || onlyApproved == true
          ? ([...action.payload.reminder.approvedItems] as any)
          : [];
      let forceItems =
        onlyforce == null || onlyforce == true
          ? ([...action.payload.reminder.forceItems] as any)
          : [];
      let pendingItems =
        onlyforce == null || onlyforce == true
          ? ([...action.payload.reminder.pendingItems] as any)
          : [];
      if (isNotify === true && state.append == true) {
        if (onlyApproved == null || onlyApproved == true)
          approvedItems = [
            ...reminderNotify.approvedItems,
            ...action.payload.reminderNotify.approvedItems,
          ] as any;
        if ((onlyforce == null || onlyforce == true) && forceItems.length > 0)
          forceItems = [
            ...reminderNotify.forceItems,
            ...action.payload.reminderNotify.forceItems,
          ] as any;
        if (onlyforce == null || onlyforce == true)
          pendingItems = [
            ...reminderNotify.pendingItems,
            ...action.payload.reminderNotify.pendingItems,
          ] as any;
      } else if (state.append == true) {
        if (onlyApproved == null || onlyApproved == true)
          approvedItems = [
            ...reminder.approvedItems,
            ...action.payload.reminder.approvedItems,
          ] as any;
        if (onlyforce == null || onlyforce == true)
          forceItems = [
            ...reminder.forceItems,
            ...action.payload.reminder.forceItems,
          ] as any;
        if (onlyforce == null || onlyforce == true)
          pendingItems = [
            ...reminder.pendingItems,
            ...action.payload.reminder.pendingItems,
          ] as any;
      }
      if (isNotify == true)
        s.reminderNotify = {
          approvedItems,
          forceItems,
          pendingItems,
        };
      else
        s.reminder = {
          approvedItems,
          forceItems,
          pendingItems,
        };
      s.loadingInstance = false;
      s.endOfPendingList =
        action.payload.reminder.forceItems.length +
        action.payload.reminder.pendingItems.length <
        10;
      s.endOfList =
        action.payload.reminder.approvedItems.length +
        action.payload.reminder.forceItems.length +
        action.payload.reminder.pendingItems.length <
        10;

      return {
        ...s,
      };
    }

    case ActionTypes.GET_REMINDER: {
      let s = { ...state };
      let a = action.payload;
      s.isNotify = a.isNotify;

      let { onlyApproved, onlyforce } = action.payload;
      if (action.payload.pageIndex === 0) {
        s.endOfPendingList = false;
      }
      s.pageIndex = action.payload;
      s.onlyApproved = onlyApproved;
      s.onlyforce = onlyforce;
      s.loadingInstance = true;
      s.append = a.append;
      return {
        ...s,
        sendRequest: true,
      };
    }

    case ActionTypes.CHANGE_REMINDER: {
      return {
        ...state,
        notifyId: action.payload.notifyId,
        isFinal: action.payload.isFinal,
      };
    }
    case ActionTypes.GET_REMINDER_RECEIVERS: {
      return {
        ...state,
        params: action.payload,
      };
    }

    case ActionTypes.FETCH_REMINDER_RECEIVERS_SUCCESS: {
      return {
        ...state,
        reminderReceivers: action.payload,
      };
    }
    case ActionTypes.CHANGE_REMINDER_STATE_ITEM_VALUE_WITH_TYPE: {
      if (action.payload.type === "" || action.payload.key === "")
        return {
          ...state,
        };

      let { reminderModel } = state as any;
      let itemKey = action.payload.key;
      let value: IreceiversOrg = {
        id:
          action.payload.value.id ||
          action.payload.value.code ||
          action.payload.value.personCode,
        text: action.payload.value.text || action.payload.value.name,
        sendSms: false,
        isConfidential: false,
        sendEmail: false,
        realName: action.payload.value.text || action.payload.value.name,
        type: 2,
      };
      let doType = action.payload.type;
      if (doType === "ADD") {
        let compare: any;
        compare = reminderModel[itemKey].filter(
          (item: any) => item.personCode === value.id
        );
        if (compare.length === 0) {
          compare = reminderModel[itemKey].filter(
            (item: any) => item.code === value.id
          );
          if (compare.length === 0)
            compare = reminderModel[itemKey].filter(
              (item: any) => item.id === value.id
            );
        }
        if (compare.length <= 0) {
          reminderModel[itemKey].push(value.id);
        }
      } else if (doType === "DEL") {
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item.personCode !== value.id
        );
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item.code !== value.id
        );
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item.id !== value.id
        );
        reminderModel[itemKey] = reminderModel[itemKey].filter(
          (item: any) => item !== value.id
        );
      }

      return {
        ...state,
      };
    }
    case ActionTypes.ADD_REMINDER: {
      let addReminderModel = {
        letterCode: action.payload.letterCode,
        deadLine: action.payload.deadLine,
        receiverCode: action.payload.receiverCode,
        text: action.payload.text,
      };
      return {
        ...state,
        addReminderModel,
      };
    }

    default:
      return state;
  }
};
